export default "__VITE_ASSET__DX4UOl07__"